/**
 * Enum que representa los primeros pasos del usuario
 */
export enum Step {
  /**
   * Paso 1: Agendar asesoría.
   */
  FIRST = 1,

  /**
   * Paso 2: Validar identidad.
   */
  SECOND = 2,

  /**
   * Paso 3: Firmar contrato.
   */
  THIRD = 3,

  /**
   * Paso 4: Primera inversión.
   */
  FOURTH = 4,

  /**
   * Paso 5: Proceso completado.
   */
  DONE = 5,
}
